import React from 'react';

import Navigation from './navigation';

export default class Header
extends React.Component {
	render() {
		const { member } = this.props;
		const { firstName, lastName } = member;

		return (
				<div className="grid-x header-grid">
					<div className="cell auto padding-left-1">
						<div className="subheader margin-top-1 margin-left-1">
							My Music
						</div>
						<Navigation />
					</div>
				</div>
		);
	}
}
